module.exports = __webpack_public_path__ + "img/video_9.846a95cc.png";